(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name agents.edit.controller:EditCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main.submain.edit')
    .controller('UsuarisMainEditCtrl', UsuarisMainEditCtrl);

  function UsuarisMainEditCtrl($scope,usuariData,$translate,$state,$window,llistarols, $rootScope,$stateParams,UsuariFactory,Notification,llistaentitats,llistaproductes,HelperFactory) {
    var vm = this;
    var vm = this;
    vm.ctrlName = 'UsuarisMainEditCtrl';
    vm.usuari=usuariData.data;
    vm.showtransclude=true;
    vm.isNew =angular.isUndefined(vm.usuari);
    vm.selectedItemChip=null;
    vm.deletedItemChip=null;

    //llista de tots els productesbotiga de totes les entitats
    vm.productesbotiga=llistaproductes.data.list;
    //llista de totes les entitats
    vm.listallentitat=llistaentitats.data.list;
    vm.formularispan=5;
    vm.formularibotiga=6;
    vm.formularirols=7;
    vm.entitatselected=null;
    vm.identitatselected=null;
    vm.textchipproducte=$translate.instant('ENTITATPRODUCTE_CERCA');
    vm.nomentitatselected='';

    if (!angular.isUndefined(vm.usuari)) {
     if (vm.usuari.confirmat && !vm.usuari.deleted){
          vm.estatusuari= $translate.instant('USUARI_CONFIRMAT_TITOL'); 
      }else if (vm.usuari.deleted || vm.usuari.fictici){
        vm.estatusuari= $translate.instant('USUARI_NO_REGISTRAT_TITOL');
        vm.colorestat='color-vermell';
      }else if((!vm.usuari.deleted && !vm.usuari.fictici && !vm.usuari.confirmat)){
        vm.estatusuari= $translate.instant('USUARI_NO_CONFIRMAT_TITOL');
        vm.colorestat='color-groc';
      }
    }

    if (angular.isUndefined(vm.usuari)) {
        vm.showtransclude=false;
        vm.usuari = {entitats:[],rolsbyent:[],rols:[],productes:[],productesbyent:[]};
        if (!$rootScope.issuperadmin){
          if (llistaentitats.data.list.length>0){
            vm.usuari.entitats.push(llistaentitats.data.list[0]);
          }
        }
    }

    if (!angular.isUndefined(vm.usuari)) {
      if (vm.usuari.entitats.length>0){
          selectEntitatChip(0);
          vm.usuari.rolsbyent=vm.usuari.rols.filter(createFilterByEntitat(vm.identitatselected));
          productesBotigaByEntitatAssignats();
      }
    }
//Actualitza la llista de productes botiga assignats segons els rols
    function productesBotigaByEntitatAssignats() {
      if (vm.productesbotiga!=null){
          var listprodbotbyent=vm.productesbotiga.filter(createFilterByEntitat(vm.identitatselected));
          vm.usuari.productesbyent=[];
          //productebotiga de l'entitat
          for(var j = 0; j<listprodbotbyent.length;j++){
            var numprod=0;
            for(var i = 0; i<listprodbotbyent[j].idsproductesprincipals.length;i++){
                var idprod=listprodbotbyent[j].idsproductesprincipals[i];
                for(var k = 0; k<vm.usuari.rolsbyent.length;k++){
                  if(vm.usuari.rolsbyent[k].idproducte=== idprod){
                    numprod++;
                    break;
                  }
                }
              }
              if (numprod>0 && numprod===listprodbotbyent[j].idsproductesprincipals.length){
                  vm.usuari.productesbyent.push(listprodbotbyent[j]);
              }
          }
      }
    }


    vm.listallrolsentitat= llistarols.data.list.filter(createFilterByEntitat(vm.identitatselected));
    vm.productesbotigabyent=[];
    if (vm.productesbotiga!=null){
      vm.productesbotigabyent= vm.productesbotiga.filter(createFilterByEntitat(vm.identitatselected));
    }



    vm.onChangeFunction = onChangeFunction;
    function onChangeFunction(){
      vm.formulari.camps[vm.formularirols].list=llistarols.data.list.filter(createFilterByEntitat(vm.identitatselected));
      vm.formulari.camps[vm.formularibotiga].list=vm.productesbotiga.filter(createFilterByEntitat(vm.identitatselected));
        //si hi ha menys entitats de les originals haurem d'eliminar de la llista de rols ja
        //seleccionats el rols que de les entitats eliminades
           var trobat=false;
           for (var i = 0; i < vm.usuari.rols.length; i++){
              for (var j = 0; j < vm.usuari.entitats.length; j++){
                if (vm.usuari.rols[i].identitat === vm.usuari.entitats[j].id){
                  trobat =true;
                  break;
                }
              }
              if (!trobat)
              {
                  vm.usuari.rols.splice(i,1);
                  i--;
              }
              trobat=false;
            }
            var listrolbyent=vm.usuari.rols.filter(createFilterByEntitat(vm.identitatselected));
            vm.usuari.rolsbyent=listrolbyent;
            vm.formulari.camps[vm.formularirols].list=llistarols.data.list.filter(createFilterByEntitat(vm.identitatselected));
            productesBotigaByEntitatAssignats();
          //  selectEntitatChip(vm.identitatselected)
      }


      vm.onChangeRolFunction = onChangeRolFunction;
      function onChangeRolFunction(){
        for (var i = 0; i < vm.usuari.rols.length; i++){
          if (vm.usuari.rols[i].identitat===vm.identitatselected) {
                if (vm.usuari.rolsbyent.indexOf(vm.usuari.rols[i])===-1 ){
                  vm.usuari.rols.splice(i,1);
                }
           }
         }
         for (var i = 0; i <vm.usuari.rolsbyent.length; i++){
              if (vm.usuari.rols.indexOf(vm.usuari.rolsbyent[i])===-1 ){
                vm.usuari.rols.push(vm.usuari.rolsbyent[i]);
              }
          }
          productesBotigaByEntitatAssignats();
          onSelectFunction(vm.entitatselected);
      }

      vm.onSelectFunction = onSelectFunction;
      function onSelectFunction(chip){

        if (!angular.isUndefined(chip)){
            vm.identitatselected=chip.id;
            vm.entitatselected=chip;
            vm.formulari.camps[vm.formularispan].text=chip.nom;
            var listrolbyent=llistarols.data.list.filter(createFilterByEntitat(vm.identitatselected));
            vm.formulari.camps[vm.formularirols].list=listrolbyent;
            vm.usuari.rolsbyent=[];
            for(var j = 0; j<vm.usuari.rols.length;j++){
              if (vm.usuari.rols[j].identitat===vm.identitatselected){
                  vm.usuari.rolsbyent.push(vm.usuari.rols[j]);
              }
            }
            vm.formulari.camps[vm.formularibotiga].list=vm.productesbotiga.filter(createFilterByEntitat(vm.identitatselected));
            productesBotigaByEntitatAssignats();
        }

      }

      vm.onDeleteProducteFunction = onDeleteProducteFunction;
      function onDeleteProducteFunction(chip){
          var prodbotigaeliminat=chip;
          var productesusuari=[];
          var idsprodeliminar=[];
          var listrolsfinal=[];

          for (var j=0;j<vm.usuari.productesbyent.length;j++){
            for (var i=0;i<vm.usuari.productesbyent[j].idsproducte.length;i++){
              productesusuari.push(vm.usuari.productesbyent[j].idsproducte[i]);
            }
          }
          for(var i=0;i<prodbotigaeliminat.idsproducte.length;i++)
          {
            if (productesusuari.indexOf(prodbotigaeliminat.idsproducte[i])===-1){
              idsprodeliminar.push(prodbotigaeliminat.idsproducte[i]);
            }
          }
          for (var j=0;j<vm.usuari.rols.length;j++){
            if ((vm.usuari.rols[j].identitat===vm.identitatselected &&
              idsprodeliminar.indexOf(vm.usuari.rols[j].idproducte)===-1)
            || vm.usuari.rols[j].identitat!==vm.identitatselected ){
                listrolsfinal.push(vm.usuari.rols[j]);
            }
          }

          vm.usuari.rols=listrolsfinal;
          vm.usuari.rolsbyent=listrolsfinal.filter(createFilterByEntitat(vm.identitatselected));
      }

      vm.onAddProducteFunction = onAddProducteFunction;
      function onAddProducteFunction(chip){
        var prodbotigaafegit=chip;
        var prodassignats=[];
        var llistarolsbyent=llistarols.data.list.filter(createFilterByEntitat(vm.identitatselected));

        for(var j=0;j<vm.usuari.rolsbyent.length;j++){
            prodassignats.push(vm.usuari.rolsbyent[j].idproducte);
        }

        for(var i =0;i<prodbotigaafegit.idsproducte.length;i++){
          if (prodassignats.indexOf(prodbotigaafegit.idsproducte[i])===-1){
            for (var k =0;k<llistarolsbyent.length;k++){
                  if(llistarolsbyent[k].idproducte===prodbotigaafegit.idsproducte[i] && llistarolsbyent[k].inicial){
                    vm.usuari.rols.push(llistarolsbyent[k]);
                    vm.usuari.rolsbyent.push(llistarolsbyent[k]);
                    break;
                  }
              }
          }
        }
      }

      function createFilterByEntitat(identitatselected) {
           return function filterFn(item) {
                 if (item.identitat === identitatselected){
                    if (!$rootScope.issuperadmin && item.liccaducada){
                        return false;
                    }
                    else{ 
                       return true;
                    }
                 }
                 return false;
             };
       }

       function selectEntitatChip(index)
       {
          if(vm.usuari.entitats.length>0){
            vm.selectedItemChip=vm.usuari.entitats[index];
            vm.identitatselected=vm.usuari.entitats[index].id;
            vm.nomentitatselected=vm.usuari.entitats[index].nom;
          }
       }


    //idioma que ha seleccionat l'usuari al registre
     vm.idiomaList = [{id:0, name: $translate.instant('DEFAULT_CATALA')},
                    {id:1, name: $translate.instant('DEFAULT_ESPANYOL')},
                    {id:2, name: $translate.instant('DEFAULT_ANGLES')}];

    if (!vm.isNew){
        if(vm.usuari.idioma!=null){
          vm.usuari.idiomaObj = vm.idiomaList[vm.usuari.idioma];
        }
        else
        {
          vm.usuari.idiomaObj=vm.idiomaList[0];
        }
    }



    vm.idUsuari = $stateParams.idUsuari;
    vm.errors = [];

    //functions
    vm.back = back;
    vm.notificarregistre=notificarregistre;
    vm.notificarconfirmar=notificarconfirmar;
    vm.readonlylistentitat=!$rootScope.issuperadmin;

    vm.formulari = {
      nom: 'formulariUsuari',
      func: func,
      camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              required: false,
              columns: 6,
              maxLength: 200,
              disabled:!vm.isNew && !$rootScope.issuperadmin
            },
            {
              type: 'text',
              name: 'cognom',
              label: 'DEFAULT_COGNOM',
              required: false,
              columns: 6,
              maxLength: 200,
              disabled:!vm.isNew && !$rootScope.issuperadmin
            },
            {
              type: 'text',
              name: 'username',
              label: 'DEFAULT_USERNAME',
              required: true,
              columns: 6,
              maxLength: 255,
              disabled:!vm.isNew && !$rootScope.issuperadmin
            },
            {
              type: 'select',
              name: 'idiomaObj',
              propertyLabel: 'name',
              propertyId: 'id',
              label: 'DEFAULT_IDIOMA',
              list: vm.idiomaList ,
              columns: 6,
              required: true,
              disabled:!vm.isNew && !$rootScope.issuperadmin
            },
             {
              type: 'chips',
              name: 'entitats',
              list:vm.listallentitat,
              onChange: onChangeFunction,
              onSelect: onSelectFunction,
              fieldProperty: 'nom',
              textPlaceholder: $translate.instant('USUARIENTITAT_CERCA'),
              createNew: false,
              columns: 12,
              readonly:vm.readonlylistentitat,
              label:"Cerca entitats",
              mdMinLenght:0,
              mdSeletedItem:vm.selectedItemChip
            },
            {
             type: 'span',
             show:true,
             text:vm.nomentitatselected,
             classText:'span-color-title'
            },
            {
              type: 'chips',
              name: 'productesbyent',
              list:vm.productesbotigabyent ,
              onDelete: onDeleteProducteFunction,
              onAdd: onAddProducteFunction,
              fieldProperty: 'nom',
              textPlaceholder: $translate.instant('ENTITATPRODUCTE_CERCA'),
              createNew: false,
              columns: 12,
              readonly:false,
              label:"Cerca productes",
              mdMinLenght:0,
              mdSeletedItem:vm.selectedItemProdBotigaChip,
              mdDeletedItem:vm.deletedItemChip
            },
            {
              type: 'chips',
              name: 'rolsbyent',
              list:vm.listallrolsentitat,
              onChange: onChangeRolFunction,
              fieldProperty: 'nom',
              textPlaceholder: $translate.instant('USUARIROL_CERCA'),
              createNew: false,
              columns: 12,
              readonly:false,
              label:"Cerca entitats",
              mdMinLenght:0
            },
            {
              type: 'text',
              name: 'accesdata',
              label: 'DEFAULT_DATA_ACCES',
              required: false,
              columns: 6,
              maxLength: 255,
              disabled:true
            },
            {
              type: 'text',
              name: 'accesip',
              label: 'DEFAULT_IP_ACCES',
              required: false,
              columns: 6,
              maxLength: 255,
              disabled:true
            },
            {
              type: 'checkbox',
              name: 'infoitec',
              label: 'USUARI_INFOITEC',
              required: false,
              columns: 12,
              disabled:!vm.isNew && !$rootScope.issuperadmin
            }, 
            {
              type: 'checkbox',
              name: 'confirmat',
              label: 'USUARI_CONFIRMAT_EDIT',
              required: false,
              columns: 12,
              disabled: vm.isNew || !$rootScope.issuperadmin || vm.usuari.fictici==true
            },
              {
              type: 'multiTransclude',
              block: 'notificar-registre-button',
              columns: 6,
              show:vm.showtransclude
            },
            {
              type: 'multiTransclude',
              block: 'notificar-deleted-button',
              columns: 12,
              show:vm.showtransclude
            },
            {
              type: 'multiTransclude',
              block: 'notificar-confirmar-button',
              columns: 12,
              show:vm.showtransclude
            }
      ]
    };

    function func() {
      vm.usuari.idioma =vm.usuari.idiomaObj.id;
      if (vm.isNew) {
        return createNew();
      }
      else {
        return edit();
      }
    }

    function createNew() {
      var promise=UsuariFactory.add(vm.usuari).then(function (response) {
        vm.usuari.id = response.data;
        vm.usuari.fictici=true;
        $rootScope.$broadcast('usuaris.main.llista.add', vm.usuari);
        HelperFactory.setParams($stateParams, {'idUsuari': response.data});
        $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
         if(vm.usuari.idioma!=null){
            vm.usuari.idiomaObj = vm.idiomaList[vm.usuari.idioma];
          }
          else
          {
            vm.usuari.idiomaObj=vm.idiomaList[0];
          }
      });
      return promise;
    }

    function edit() {
      var promise=UsuariFactory.update(vm.idUsuari, vm.usuari).then(function (response){
      $rootScope.$broadcast('usuaris.main.llista.update', vm.usuari);
      $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
         if(vm.usuari.idioma!=null){
            vm.usuari.idiomaObj = vm.idiomaList[vm.usuari.idioma];
          }
          else
          {
            vm.usuari.idiomaObj=vm.idiomaList[0];
          }
      });
      return promise;
    }

    function back() {
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
      if (vm.isNew) {
        $state.go('usuaris.main', $stateParams, {'reload': 'usuaris.main.submain'});
      }
      else {
        $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
      }
    }

    function notificarregistre() {
      UsuariFactory.avisregistre(vm.idUsuari).then(function (response){
      Notification.success('SUCCESS_AVIS_REGISTRE');
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }

    function notificarconfirmar() {
      UsuariFactory.avisconfirmar(vm.idUsuari).then(function (response){
      Notification.success('SUCCESS_AVIS_CONFIRMAR');
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }


    if (vm.isNew) {
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': true});
    }
  }
}());
